import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MetalsCalculator from './pages/MetalsCalculator';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MetalsCalculator />} />
      </Routes>
    </Router>
  );
}

export default App;
